import React from "react";

interface CheckoutMoneyInputProps {
  value: string | number;
  onChange: (value: string) => void;
  placeholder?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  type?: string;
  disabled?: boolean;
  prefix?: string;
  className?: string;
  min?: number;
}

const CheckoutMoneyInput: React.FC<CheckoutMoneyInputProps> = ({
  value,
  onChange,
  placeholder,
  inputMode,
  type = "text",
  disabled = false,
  prefix = "¥",
  className = "",
  min,
}) => (
  <div className={`split-discount-money-input${className ? ` ${className}` : ""}`}>
    <span>{prefix}</span>
    <input
      type={type}
      min={min}
      inputMode={inputMode}
      className="form-control no_spring_input"
      placeholder={placeholder}
      disabled={disabled}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    />
  </div>
);

export default CheckoutMoneyInput;
